document.addEventListener('DOMContentLoaded', function() {

    //language selector form
    const languageForm = document.querySelector("#language-selector-footer");
    const allLanguages = languageForm?.querySelectorAll('input[name="language_code"]');
    allLanguages?.forEach(language => {
      language.addEventListener('change', function() {
        languageForm.submit();
      });
    });
    
    const languageInputs = document.querySelectorAll('#details-ls.language input[name="language_code"]');
    const languagelabels = document.querySelectorAll('#details-ls.language .country-selector-list li label');

    function updateSelectedLanguage() {
      languageInputs?.forEach((radio, index) => {
        if (radio.checked) {
          languagelabels[index].classList.add('selected');
        } else {
          languagelabels[index].classList.remove('selected');
        }
      });
    }
    updateSelectedLanguage();

    languageInputs?.forEach((radio) => {
      radio.addEventListener('change', updateSelectedLanguage);
    });
  });

  